import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useUserRoles } from "@/hooks/useUserRoles";
import { Loader2 } from "lucide-react";

interface Props {
  children: React.ReactNode;
  requireRole: "executive" | "manager";
}

const RoleProtectedRoute = ({ children, requireRole }: Props) => {
  const { user, loading: authLoading } = useAuth();
  const { isManager, isExecutive, loading: rolesLoading } = useUserRoles();
  const location = useLocation();

  if (authLoading || rolesLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) return <Navigate to="/signin" state={{ from: location }} replace />;

  if (requireRole === "executive" && !isExecutive) return <Navigate to="/home" replace />;
  if (requireRole === "manager" && !isManager) return <Navigate to="/home" replace />;

  return <>{children}</>;
};

export default RoleProtectedRoute;
